function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-1_454_10106",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 12H35C35 31.33 19.33 47 0 47V12Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 12H35C35 31.33 19.33 47 0 47V12Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 12H35H0ZM35.5 12C35.5 31.6061 19.6061 47.5 0 47.5H-2L2 46.5H0C19.0538 46.5 34.5 31.0538 34.5 12H35.5ZM-2 47.5V12H2V46.9438L1.99995 46.9428C1.33398 46.9809 0.667053 47 -6.11959e-06 47L-2 47.5ZM35.5 12C35.5 31.6061 19.6061 47.5 0 47.5V46.5C19.0538 46.5 34.5 31.0538 34.5 12H35.5Z",
  fill: "#B0B0B0",
  mask: "url(#path-1-inside-1_454_10106)"
});

var _ref5 = /*#__PURE__*/React.createElement("mask", {
  id: "path-3-inside-2_454_10106",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M70 12H35C35 31.33 50.67 47 70 47V12Z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M70 12H35C35 31.33 50.67 47 70 47V12Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M70 12H35H70ZM34.5 12C34.5 31.6061 50.3939 47.5 70 47.5H72L68 46.5H70C50.9462 46.5 35.5 31.0538 35.5 12H34.5ZM72 47.5V12H68V46.9438L68.0001 46.9428C68.666 46.9809 69.3329 47 70 47L72 47.5ZM34.5 12C34.5 31.6061 50.3939 47.5 70 47.5V46.5C50.9462 46.5 35.5 31.0538 35.5 12H34.5Z",
  fill: "#B0B0B0",
  mask: "url(#path-3-inside-2_454_10106)"
});

var _ref8 = /*#__PURE__*/React.createElement("mask", {
  id: "path-5-inside-3_454_10106",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M70 0H0V13H70V0Z"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M70 0H0V13H70V0Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M70 0V-1C70.5523 -1 71 -0.552285 71 0L70 0ZM0 0H-1C-1 -0.552285 -0.552284 -1 0 -1V0ZM70 1H0V-1H70V1ZM1 0V13H-1V0H1ZM69 13V0H71V13H69Z",
  fill: "#B0B0B0",
  mask: "url(#path-5-inside-3_454_10106)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M70 12.5L5.51939e-05 12.4926",
  stroke: "#B0B0B0",
  strokeDasharray: "2 2"
});

var SvgDoubleDoors = function SvgDoubleDoors(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 47,
    viewBox: "0 0 70 47",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoubleDoors, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doubleDoors.f3e5fa39.svg";
export { ForwardRef as ReactComponent };